<template>
    <div>
        <b-modal
            id="shipping_address_modal"
            modal-class=""
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="modal-base-close" @click="clickCloseAddressModal()"></div>
                    <div class="headline">
                        <div v-if="type == 'edit'">แก้ไขที่อยู่จัดส่ง</div>
                        <div v-else>กรุณาระบุที่อยู่จัดส่ง</div>
                    </div>
                </div>
                <div class="modal-base-body"
                    v-if="formAddress && addressModel">
                    <text-input
                        inputId="shipping_name"
                        v-model="addressModel.addressName"
                        :inputLbl="lblShipping.name"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="isShowErrorLbl"
                        :errorInfo="arrErrorInfo[0]"
                        :isTextOnly="false"
                        @input="onUpdate()"
                        ></text-input>
                    <text-input
                        inputId="shipping_firstname"
                        v-model="addressModel.firstname"
                        :inputLbl="lblShipping.firstname"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="isShowErrorLbl"
                        :errorInfo="arrErrorInfo[1]"
                        :isTextOnly="true"
                        @input="onUpdate()"
                        ></text-input>
                    <text-input
                        inputId="shipping_lastname"
                        v-model="addressModel.lastname"
                        :inputLbl="lblShipping.lastname"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="isShowErrorLbl"
                        :errorInfo="arrErrorInfo[2]"
                        :isTextOnly="true"
                        @input="onUpdate()"
                    ></text-input>
                    <contact-number-input
                        inputId="shipping_contact_number"
                        v-model="addressModel.contactNumber"
                        :inputLbl="lblShipping.contactnumber"
                        :isFirstSave="isFirstSave"
                        :errorInfo="arrErrorInfo[3]"
                        @input="onUpdate()"
                        ></contact-number-input>
                    <text-input
                        inputId="shipping_address"
                        v-model="addressModel.address"
                        :inputLbl="lblShipping.address"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="isShowErrorLbl"
                        :errorInfo="arrErrorInfo[4]"
                        @input="onUpdate()"
                        ></text-input>
                    <form-address-dropdown
                        formId="shipping"
                        :address="formAddress"
                        :lblShipping="lblShipping"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="isShowErrorLbl"
                        :zipcodeError="arrErrorInfo[5]"
                        :subDistrictError="arrErrorInfo[6]"
                        :districtError="arrErrorInfo[7]"
                        :provinceError="arrErrorInfo[8]"
                        :busModal="busModal"
                        @input="onUpdate()"
                        ></form-address-dropdown>
                    <check-box
                        v-model="addressModel.isDefault"
                        :value="addressModel.isDefault"
                        :textLbl="lblShipping.save_address"
                        @update:check="updateIsDefault($event)"
                        ></check-box>                    
                </div>
                <div class="modal-base-footer">
                    <button class="btn-save" :class="!isDisableBtn ? 'allow' : ''" @click="clickConfirmAddress()">บันทึก</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
//import Vue from "vue";
import TextInput from "@/components/common/input/Text.vue";
import ContactNumberInput from "@/components/common/input/ContactNumber.vue";
import CheckBox from "@/components/common/input/CheckBox.vue";
import FormAddressDropdown from "@/components/common/form/FormAddressDropDown.vue";
/**
 * Property
 * @property {lblShipping} (required) Text for component
 * @property {shippingAddress} (required) Shipping address model for redeem.
 * @property {errorInfo} (required) Validate status.
 * Event
 * @event clickConfirmAddress Validate and emit back to parent.
 * @event clickCloseShippingAddressModal Close modal.
 * Method
 * @method initialShippingAddressModal Setup shipping modal
 * @method closeShippingAddressModal Close modal.
 * @method validateForm Validate form.
 */
export default {
    name : 'ShippingAddressModal',
    components: {
        TextInput,
        ContactNumberInput,
        CheckBox,
        FormAddressDropdown
    },
    props: {
        lblShipping: Object,
        formAddress: Object,
        addressModel: Object,
        errorInfo: Object,
        type: String,

        busModal: Object,
        busShippingModal: Object
    }, 
    data: function () {
        return {
            isSaveAddress: false,
            isShowErrorLbl: false,
            isFirstSave: true,
            arrErrorInfo: [],
            isDisableBtn: true,
        };
    },
    created: function () {
        for(var i = 0;i < 9; i++) {
            this.arrErrorInfo.push({
                isValid: true,
                msg: '',
            });
        }
    },
    mounted: function () {
        this.busShippingModal.$on('showShippingAddressModal', this.initialShippingAddressModal);
        this.busShippingModal.$on('hideShippingAddressmodal', this.closeShippingAddressModal);
    },
    methods: {
        //Event
        clickConfirmAddress: function () {
            if (this.isDisableBtn) return;

            this.validateForm();
            if (this.type == 'edit') {
                this.$emit('clickUpdateAddress');
            } else {
                this.$emit('clickConfirmAddress');
            }
            this.closeAddressModal();
            this.isFirstSave = false;
        },
        clickCloseAddressModal: function () {
            this.isFirstSave = true;
            this.closeAddressModal();
        },
        //Function
        initialShippingAddressModal: function () {
            this.$bvModal.show('shipping_address_modal');
        },
        closeAddressModal: function () {
            this.$bvModal.hide('shipping_address_modal');
        },
        validateForm: function () {
            //Set default.
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';
            //Check validate result and update.
            for(var error of this.arrErrorInfo) {
                if(!error.isValid) {
                    this.errorInfo.isValid = false;
                    this.errorInfo.msg = error.msg;
                    
                    return;
                }
            }
        },
        validate: function() {
            for (var i of this.arrErrorInfo) {
                if (!i.isValid) {
                    return false;
                }
            }
            return true;
        },
        updateIsDefault: function (isActive) {
            this.addressModel.isDefault = isActive
        },
        onUpdate: function() {
            if (this.validate()) {
                this.isDisableBtn = false
            } else {
                this.isDisableBtn = true
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/component/modal/modal.scss";

#shipping_address_modal {
    @extend %modal-base;
    .modal-base {
        max-height: calc(100vh - 80px);
        overflow: hidden;
        .modal-base-head {
            .headline {
                padding-top: 16px;
                text-align: center;
                font-weight: bold;
                font-size: 24px;
                color: #0e78c1;
            }
        }
        .modal-base-body {
            height: calc(100vh - 270px);
            overflow-y: scroll;
            overflow-x: hidden;
            margin-top: 30px;
            margin-bottom: 12px;
        }
        .modal-base-footer {
            .btn-save {
                width: 100%;
                background-color: #e9e9e9;
                border: #e9e9e9;
                border-radius: 5px;
                padding: 6px 0;
                color: #9f9f9f;
                font-size: 24px;
                font-weight: 500;
                &.allow {
                    color: white;
                    background-image: url('../../assets/campaign/button_redeem@2x.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                }
            }
        }
    }
}

#headline {
    font-size: 1.25rem;
    font-weight: bold;
}
</style>